/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import React, { ReactNode } from "react";

import BackIcon from "../../../../shared/icons/navigation/Chevron_left.svg";

import { useActiveSection } from "./ActiveSectionContext";

import "./DropdownHeader.scss";

interface DropdownHeaderProps {
  navigateToSection?: string;
  children: ReactNode;
}

export const DropdownHeader = (props: DropdownHeaderProps) => {
  const { navigateToSection, children } = props;

  const { setSection } = useActiveSection();

  const onClick = () => navigateToSection && setSection(navigateToSection);

  return (
    <div className="DropdownHeader" onClick={onClick}>
      {navigateToSection && <BackIcon aria-hidden="true" focusable="false" />}
      {children}
    </div>
  );
};
